import {pageInfo,importData,downtemplate} from './../api';
import {supplierList, plant,storageList} from '../../../../../api'
import {Message} from 'element-ui';

const purchUnloadPlan = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
    storageObj: [],
    importDataObj: [],
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    STORAGE_LIST(state, data) {
      state.storageObj = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async importData({commit}, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    async storageList({commit},obj){
      let resp = await storageList(obj);
      commit('STORAGE_LIST',resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await downtemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
  }
}
export default purchUnloadPlan



// WEBPACK FOOTER //
// ./src/page/bd/plan/purchUnloadPlan/store/purchUnloadPlan.store.js